export default __webpack_public_path__ + "static/media/diabetes.22c6939f.png";